import { ProctoringMethod } from "@verity/proctoring-option/types";
import AutomatedIcon from "../images/method/automated.svg?react";
import LiveIcon from "../images/method/live.svg?react";
import LiveCheckInIcon from "../images/method/live-check-in.svg?react";
import PostReviewIcon from "../images/method/post-review.svg?react";
import CourseIcon from "../images/profiles/course.svg?react";
import InstitutionIcon from "../images/profiles/institution.svg?react";
import PersonalIcon from "../images/profiles/personal.svg?react";
import AdvancedIcon from "../images/profiles/advanced.svg?react";
import StandardIcon from "../images/profiles/standard.svg?react";
import EssentialIcon from "../images/profiles/essential.svg?react";
import { ProctoringOptionProfileType } from "@verity/database/prisma";
import { PresetProfileType } from "../profile/profileHelpers";
import i18nPackage from "../../i18n/i18n";

export const METHOD_ICON_CONFIG: Record<ProctoringMethod, typeof LiveIcon> = {
	"pop-in": LiveCheckInIcon,
	"pop-in-post-review": PostReviewIcon,
	automated: AutomatedIcon,
	live: LiveIcon,
};

export type ProfileConfigType = {
	Icon: typeof CourseIcon; // So VITE doesn't complain and hot reload everytime ProfileList is saved
	name: string;
	description: string;
	bgColor: string;
	svgColor: string;
};

export const PROFILE_CONFIG: Record<
	Exclude<ProctoringOptionProfileType, "assessment" | "preset">,
	ProfileConfigType
> & {
	preset: Record<PresetProfileType, ProfileConfigType>;
} = {
	course: {
		name: i18nPackage.t("editQuizPage.profileStep.course.name"),
		description: i18nPackage.t("editQuizPage.profileStep.course.desc"),
		Icon: CourseIcon,
		bgColor: "#FCF3FC",
		svgColor: "#C834CB",
	},
	institute: {
		name: i18nPackage.t("editQuizPage.profileStep.institution.name"),
		description: i18nPackage.t("editQuizPage.profileStep.institution.desc"),
		Icon: InstitutionIcon,
		bgColor: "#F2F1FE",
		svgColor: "#504BB0",
	},
	user: {
		name: i18nPackage.t("editQuizPage.profileStep.user.name"),
		description: i18nPackage.t("editQuizPage.profileStep.user.desc"),
		Icon: PersonalIcon,
		bgColor: "#FAEFE0",
		svgColor: "#8B5D14",
	},
	preset: {
		advanced: {
			name: i18nPackage.t("editQuizPage.profileStep.advanced.name"),
			description: i18nPackage.t("editQuizPage.profileStep.advanced.desc"),
			Icon: AdvancedIcon,
			bgColor: "#E3F2FD",
			svgColor: "#1565C0",
		},
		standard: {
			name: i18nPackage.t("editQuizPage.profileStep.standard.name"),
			description: i18nPackage.t("editQuizPage.profileStep.standard.desc"),
			Icon: StandardIcon,
			bgColor: "#E3F2FD",
			svgColor: "#1565C0",
		},
		essential: {
			name: i18nPackage.t("editQuizPage.profileStep.essential.name"),
			description: i18nPackage.t("editQuizPage.profileStep.essential.desc"),
			Icon: EssentialIcon,
			bgColor: "#E3F2FD",
			svgColor: "#1565C0",
		},
	},
};
